export default {
  // must be in sync with $tc-sc-width from Ribbon.scss
  // cannot use :export because server-side rendering doesn't support CSS modules (yet?)
  baseWidth: 7,
  baseUnit: 'rem',
}